module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kvCFa"))).then(() => parcelRequire('dJXJK'));